export const environment = {
  firebase: {
    apiKey: 'AIzaSyAT-0Z2zbb0Up9Vrx9iUkhRH1plDgAtYnw',
    authDomain: 'phishsentry.firebaseapp.com',
    projectId: 'phishsentry',
    storageBucket: 'phishsentry.firebasestorage.app',
    messagingSenderId: '107701418654',
    appId: '1:107701418654:web:fee54837e05eb3bec9998f',
  },
  useEmulators: false,
  learningpage_url: 'https://learning-dev.phishlab.de/lp/',
  // temporary
  reCaptchaSiteKey: '6LcGYoQsAAAAAEEsytQgmHYFIQXihQ-9hgA1CBBM',
  production: true,
};
